import React from 'react';

import {createRoutesHook, useRouter} from './router';
import {Meeting} from './pages/Meeting.page';
import {Main} from './pages/Main.page';

const useRoutes = createRoutesHook([
    {
        exact: true,
        path: '/',
        node: Main,
    },
    {
        path: '/:id',
        node: Meeting,
    },
]);

export const App: React.FC = () => {
    useRouter();
    return <>{useRoutes()}</>;
};
